export enum ApiRelationCodeEnum {
    Partner = 'PRTR',
    Child = 'KIND',
    Owner = 'IKZE',
}
